import { Fragment } from "react";
import { SUPPORTED_LOCALES, localeName, localeShort, useLocale, useT } from "@/lib/i18n";

// Language switch in three looks: "inline" (UZ / RU / EN, the nav),
// "seg" (segmented control, the mobile menu) and "footer" (dotted names).
export function LangSwitch({ variant = "inline", className }: { variant?: "inline" | "seg" | "footer"; className?: string }) {
  const t = useT();
  const [locale, setLoc] = useLocale();
  const label = t("a11y.change_language", "Change language");

  if (variant === "seg") {
    return (
      <div className={className ? `tk-seg ${className}` : "tk-seg"} role="group" aria-label={label}>
        {SUPPORTED_LOCALES.map((l) => (
          <button key={l} type="button" lang={l} aria-pressed={locale === l} onClick={() => setLoc(l)}>
            {localeName(l)}
          </button>
        ))}
      </div>
    );
  }

  if (variant === "footer") {
    return (
      <div className={className ? `tk-footer__langs ${className}` : "tk-footer__langs"} role="group" aria-label={label}>
        {SUPPORTED_LOCALES.map((l, i) => (
          <Fragment key={l}>
            {i > 0 && <span aria-hidden="true">·</span>}
            <button type="button" lang={l} aria-pressed={locale === l} onClick={() => setLoc(l)}>
              {localeName(l)}
            </button>
          </Fragment>
        ))}
      </div>
    );
  }

  return (
    <div className={className ? `tk-lang ${className}` : "tk-lang"} role="group" aria-label={label}>
      {SUPPORTED_LOCALES.map((l, i) => (
        <Fragment key={l}>
          {i > 0 && <span className="tk-lang__sep" aria-hidden="true">/</span>}
          <button
            type="button"
            className="tk-lang__btn"
            lang={l}
            aria-pressed={locale === l}
            aria-label={localeName(l)}
            onClick={() => setLoc(l)}
          >
            {localeShort(l)}
          </button>
        </Fragment>
      ))}
    </div>
  );
}
